import { Loads, LoadType, SpansAndLoads } from 'types/domainTypes';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function useLoads(tabValue: LoadType, spansAndLoads: SpansAndLoads): { loads?: Loads; label?: string } {
  const { t } = useTranslation();
  const [loads, setLoads] = useState<Loads>();
  const [label, setLabel] = useState<string>();

  useEffect(() => {
    switch (tabValue) {
      case LoadType.PermanentLoad:
        setLoads(spansAndLoads.permanentLoads);
        setLabel(t('calculation-page.label-permanent-load'));
        break;
      case LoadType.SnowLoad:
        setLoads(spansAndLoads.snowLoads);
        setLabel(t('calculation-page.label-snow-load'));
        break;
      case LoadType.PressureLoad:
        setLoads(spansAndLoads.pressureLoads);
        setLabel(t('calculation-page.label-pressure-wind-load'));
        break;
      case LoadType.SuctionLoad:
        setLoads(spansAndLoads.suctionLoads);
        setLabel(t('calculation-page.label-suction-load'));
        break;
      case LoadType.ImposedLoad:
        setLoads(spansAndLoads.imposedLoads);
        setLabel(t('calculation-page.label-imposed-load'));
        break;
      case LoadType.ConstructionLoad:
        setLoads(spansAndLoads.constructionLoads);
        setLabel(t('calculation-page.label-construction-load'));
        break;
      case LoadType.ExcepSnowLoad:
        setLoads(spansAndLoads.excepSnowLoads);
        setLabel(t('calculation-page.label-excep-snow-load'));
        break;
    }
  }, [
    spansAndLoads.constructionLoads,
    spansAndLoads.excepSnowLoads,
    spansAndLoads.imposedLoads,
    spansAndLoads.permanentLoads,
    spansAndLoads.pressureLoads,
    spansAndLoads.snowLoads,
    spansAndLoads.suctionLoads,
    t,
    tabValue,
  ]);

  return { loads, label };
}
